import script from "./QueriesHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./QueriesHeader.vue?vue&type=script&setup=true&lang=js"

import "./QueriesHeader.vue?vue&type=style&index=0&id=da104118&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-da104118"]])

export default __exports__